import { Injectable } from '@angular/core';
import { ProductService } from './product.service';
import { ProductVariantsService } from './product-variants.service';
import { Product } from '../models/product.schema';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getCityFromAddressComponents } from '../helpers/find-province-from-address.helper';

@Injectable({
  providedIn: 'root'
})
export class CommanUsesService {

  constructor(
    protected productService: ProductService,
    protected productVariantsService: ProductVariantsService,
    protected _snackBar: MatSnackBar,
  ) { }

  async findProductSaleAutomationProcess(product: any, shippingAddress: any){
    let existingProduct: Product = null;
    const provinceCode = shippingAddress?.province_code;
    const baseSku = product.sku;
    const skuWithProvince = baseSku + provinceCode;

    /* Try finding product directly by base SKU */
    if(baseSku) {
      existingProduct = await this.productService.findProduct(baseSku);
    }

    /* Try finding product by SKU + province */
    if(!existingProduct && provinceCode) {
      existingProduct = await this.productService.findProduct(skuWithProvince);
    }

    /* Try finding variant with base SKU or SKU+province and get its product */
    if(!existingProduct) {
      const skusToTry = [baseSku, skuWithProvince];
      for (const sku of skusToTry) {
        const productVariant: any = await this.productVariantsService.findProductVariantWithSku(sku);
        if(productVariant?.product?.id) {
          const variantProduct = await this.productService.getOne(productVariant.product.id);
          existingProduct = await this.productService.findProduct(variantProduct.sku);
        }
      }
    }

    return existingProduct;
  }

  public getPlacePrediction(input: string): Promise<google.maps.places.PlaceResult | null> {
    return new Promise((resolve, reject) => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions({
        input,
        componentRestrictions: { country: ['it', 'sm', 'va', 'mc', 'ch', 'at', 'si'] },
        types: ['geocode']  // for address predictions
      }, (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
          const placeId = predictions[0].place_id;
          
          // Now get full details using the place_id
          const placesService = new google.maps.places.PlacesService(document.createElement('div')); // dummy div
          placesService.getDetails({ placeId }, (placeResult, placeStatus) => {
            if (placeStatus === google.maps.places.PlacesServiceStatus.OK && placeResult) {
              resolve(placeResult); // contains address_components, geometry, etc.
            } else {
              resolve(null);
            }
          });
  
        } else {
          resolve(null);
        }
      });
    });
  }

  async checkDeliveryAndPartnerAddressCity(deliveryAddress: string, partnerAddress: string): Promise<boolean> {
    // console.log("deliveryAddress", deliveryAddress)
    // console.log("partnerAddress", partnerAddress)
    const deliveryAddressDetails = await this.getPlacePrediction(deliveryAddress);
    const partnerAddressDetails = await this.getPlacePrediction(partnerAddress);
    // console.log("deliveryAddressDetails", deliveryAddressDetails);
    // console.log("partnerAddressDetails", partnerAddressDetails);
  
    if (!deliveryAddressDetails || !partnerAddressDetails) return false;
  
    const deliveryCity: string | null = getCityFromAddressComponents(deliveryAddressDetails.address_components);
    const partnerCity: string | null = getCityFromAddressComponents(partnerAddressDetails.address_components);
    console.log("deliveryCity", deliveryCity);
    console.log("partnerCity", partnerCity);
  
    if (deliveryCity && partnerCity) {
      return deliveryCity.toLowerCase() === partnerCity.toLowerCase();
    }
  
    return false;
  }

  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 5000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }
  
  public extractErrorMessage(error: any): string {
    const backendError = error?.error;

    // NestJS / backend response:
    // { message: 'Something went wrong' }
    if (typeof backendError?.message === 'string') {
      return backendError.message;
    }

    // NestJS validation response:
    // { message: ['name is required', 'email must be valid'] }
    if (Array.isArray(backendError?.message)) {
      return backendError.message.join('\n');
    }

    // Backend sends plain string
    if (typeof backendError === 'string') {
      return backendError;
    }

    // OpenAI direct error shape, in case it leaks through
    if (typeof backendError?.error?.message === 'string') {
      return backendError.error.message;
    }

    // Axios / HttpClient generic error message
    if (typeof error?.message === 'string') {
      return error.message;
    }

    return 'Something went wrong. Please try again.';
  }
}
